import type { ApiGenericResponse, Category } from '../../typings'

export function getCategoriesAction<T = ApiGenericResponse<Category[]>>(): Promise<T> {
  const { api } = useApi()
  return api.get<T>('/v2/service-categories')
}
